import { createContext } from 'preact'
import type { UseForm } from './useForm'

export type FormContextValue = UseForm

export const FormContext = createContext<FormContextValue>(null)

if (process.env.NODE_ENV !== 'production') {
  FormContext.displayName = 'FormContext'
}

export default FormContext
